/**
 * Filter view store for DashboardsOverview page
 */

import { createFilterViewStore } from '@/stores/filterViewUtils/createFilterViewStore';

export const useDashboardsOverviewFilterViewStore = createFilterViewStore(
  'DashboardsOverview',
  false, // Filter panel closed by default
);
